module.exports = __webpack_public_path__ + "static/media/slide-5.fea4b06b.jpg";